import './CRUDTenant.scss';
import Component from './CRUDTenant.js';
export default Component;
